import {getSearchResultsPage} from "../api/search/requests";
import {useQuery} from "@tanstack/react-query";

const useStoryblokSearchResultsPage = () =>
  useQuery({
    queryKey: ["searchResultsPage"],
    queryFn: getSearchResultsPage,
    staleTime: Infinity,
  });

export default useStoryblokSearchResultsPage;
